import Swiper, {Navigation} from "swiper";
import {MD_WIDTH, LG_WIDTH, XL_WIDTH} from "@main/helpers/const.js";

class CollaborationSlider {
    constructor(el) {
        this.el = el;
        this.section = this.el.closest(".collaboration-section");
        this.navPrev = this.section.querySelector(".js-collaboration-slider-prev");
        this.navNext = this.section.querySelector(".js-collaboration-slider-next");

        this.enableSlider();
    }

    enableSlider() {
        new Swiper(this.el, {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 24,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 48,
                },
                [LG_WIDTH]: {
                    spaceBetween: 66,
                },
                [XL_WIDTH]: {
                    spaceBetween: 82,
                }
            },
            navigation: {
                nextEl: this.navNext,
                prevEl: this.navPrev
            }
        });
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-collaboration-slider").forEach((slider) => new CollaborationSlider(slider));
});
